__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-ali-pay/').replace(/[/]{3,}/g, "/");